"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MarqueeSelection.types.js.map